import { useDesktop } from "#hooks/use-desktop"
import { useI18n } from "#hooks/use-i18n"
import { Info, Plus } from "lucide-react"
import { Button } from "../ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover"
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip"

interface PartnersHeaderActionsProps {
  canAddPartner: boolean
  onAddPartner: () => void
  isOwner: boolean
}

export function PartnersHeaderActions({
  canAddPartner,
  onAddPartner,
  isOwner,
}: PartnersHeaderActionsProps) {
  const { t } = useI18n()
  const isDesktop = useDesktop()

  if (!canAddPartner || !isOwner) {
    const tooltipMessage = !isOwner
      ? t("components.partners.headerActions.actionDisabled")
      : t("components.partners.headerActions.partnerLimitReached")

    return (
      <>
        {isDesktop ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="inline-block w-full sm:w-auto">
                <Button
                  disabled
                  className="w-full sm:w-auto shadow-sm dark:shadow-none dark:border-border/50 hover:shadow-md dark:hover:shadow-none transition-shadow"
                >
                  <Plus className="w-5 h-5 mr-2" />
                  {t("pages.partners.form.add")}
                </Button>
              </span>
            </TooltipTrigger>
            <TooltipContent side="left" className="max-w-xs">
              <p className="text-sm">{tooltipMessage}</p>
            </TooltipContent>
          </Tooltip>
        ) : (
          <div className="w-full sm:w-auto">
            <div className="flex items-center gap-2">
              <Button
                disabled
                className="flex-1 sm:flex-none shadow-sm dark:shadow-none dark:border-border/50 hover:shadow-md dark:hover:shadow-none transition-shadow"
              >
                <Plus className="w-5 h-5 mr-2" />
                Add Partner
              </Button>
              <Popover>
                <PopoverTrigger asChild>
                  <Button variant="ghost" size="icon" className="flex-shrink-0">
                    <Info className="w-5 h-5" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent side="left" className="w-80">
                  <div className="space-y-2">
                    <h4 className="font-medium leading-none">
                      {!isOwner
                        ? t("components.partners.headerActions.permissionDenied")
                        : t("components.partners.headerActions.partnerLimitReached")}
                    </h4>
                    <p className="text-sm text-muted-foreground">
                      {!isOwner
                        ? t("components.partners.headerActions.actionDisabled")
                        : t("components.partners.headerActions.partnerLimitReached")}
                    </p>
                  </div>
                </PopoverContent>
              </Popover>
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <Button
      onClick={onAddPartner}
      className="w-full sm:w-auto shadow-sm dark:shadow-none dark:border-border/50 hover:shadow-md dark:hover:shadow-none transition-shadow"
    >
      <Plus className="w-5 h-5 mr-2" />
      Add Partner
    </Button>
  )
}
